import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  asset: belongsTo('asset', { inverse: null }),
  category: belongsTo('category', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  division: belongsTo('division', { inverse: null }),
  jobFunctions: hasMany('category', { inverse: null }),
  label: belongsTo('label', { inverse: null }),
  link: belongsTo('link', { inverse: null }),
  location: belongsTo('location', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
});
